import RegisterForm from './Register';
export default RegisterForm;
